import { Text } from "react-konva";

const TitleCanvasText: React.FC<{
  x: number;
  y: number;

  text: string;
  fontFamilyName: string;
  fontSize: any;
}> = ({ text, fontFamilyName, fontSize, x, y }) => {
  return (
    <Text
      fontSize={fontSize}
      x={x}
      y={y}
      text={text}
      fill="white"
      fontFamily={fontFamilyName}
    />
  );
};

export default TitleCanvasText;
